<template>
  <div id="the-artist">
    <b-container class="the-artist-container">
      <Header title="The Artist" />
      <ImageGallery
        style="margin-top: 40px"
        :data="[
          require('@/assets/images/galleries/efdot/Artist-Slider/Efdot - Slider 01.jpg'),
          require('@/assets/images/galleries/efdot/Artist-Slider/Efdot - Slider 02.jpg'),
          require('@/assets/images/galleries/efdot/Artist-Slider/Efdot - Slider 03.jpg'),
          require('@/assets/images/galleries/efdot/Artist-Slider/Efdot - Slider 04.jpg'),
          require('@/assets/images/galleries/efdot/Artist-Slider/Efdot - Slider 05.jpg'),
        ]"
        :idString="'theartist'"
      />
      <h4>EFDOT</h4>
      <p>
        Efdot is a visual artist and community builder known for his iconic Blob
        character and abstract-meets-figurative style which explores the
        contrast between playfulness and mischief.
      </p>
      <p class="italic">
        The colors, lines, and light in this collection were inspired by the
        neurodiversity of the human condition. Depicting multiple faces through
        a mosaic of shapes felt like the best way to celebrate this idea.
      </p>
      <p>
        He has installed large-scale murals around the world and collaborated
        with notable brands such as Topps, Atlantic Records and Adobe.
      </p>

      <p>
        To learn more about Efdot, please visit:
        <a
          href="https://www.efdotstudio.com"
          target="_blank"
          v-ePitchTracking="{
            site: 'efdot',
            category: 'Link',
            label: 'Efdot',
          }"
          >www.efdotstudio.com.</a
        >
      </p>
    </b-container>
  </div>
</template>

<script>
import ImageGallery from "@/components/global/ImageGallery";
import Header from "@/components/global/Header";
export default {
  name: "TheArtist",
  components: {
    ImageGallery,
    Header,
  },
};
</script>

<style lang="scss" scoped>
#the-artist {
  padding-top: 150px;
  padding-bottom: 100px;
  @media (max-width: $md) {
    padding-bottom: 50px;
    padding-top: 75px;
  }
  .the-artist-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media (max-width: $md) {
      padding-left: 10px;
      padding-right: 10px;
    }
  }

  .italic {
    font-family: AvenirNext-Medium-Italic;
    font-size: 16px;
    color: #3e3e3e;
    text-align: center;
    line-height: 25px;
    width: 587px;
    max-width: 100%;
    &:after {
      content: url("~@/assets/images/icons/Close-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-left: 8px;
      transform: scale(0.5);
    }
    &:before {
      content: url("~@/assets/images/icons/Open-Quote-Small.svg");
      width: 16px;
      height: 10px;
      padding-right: 8px;
    }
  }
  h4 {
    font-family: "Poppins-Bold";
    font-size: 20px;
    color: #1a1a1a;
    letter-spacing: 0;
    text-align: center;
    line-height: 24px;
    text-transform: uppercase;
    margin-top: 40px;
    margin-bottom: 20px;
  }
  p {
    font-family: "AvenirNext-Regular";
    font-size: 14px;
    color: #3e3e3e;
    text-align: center;
    line-height: 23px;
    margin-bottom: 20px;
    width: 852px;
    max-width: 100%;
    &:last-child {
      margin-bottom: 0;
    }
  }
  a {
    color: $red;
    text-decoration: none;
  }
}
</style>
